import { apiFetch } from './api';

export interface ResourcePack {
  id: string;
  projectId: string;
  name: string;
  fileName: string;
  description?: string;
  repository: string;
  currentVersion?: string;
  latestAvailable?: string;
  sizeMb?: number;
  activeIn?: string[];
  deployedVersions?: Record<string, string>;
  lastDeployedAt?: Record<string, string>;
  lastSyncAt?: string;
  lastUpdateAt?: string;
  lastUpdateBy?: string;
}

export interface PackCreateInput {
  name: string;
  fileName: string;
  repository: string;
  description?: string;
  sizeMb?: number;
}

export interface PackUpdateInput {
  name?: string;
  fileName?: string;
  description?: string;
  repository?: string;
  sizeMb?: number;
}

export interface DeployPackInput {
  environments: string[];
  version?: string;
}

export interface DeployResultEntry {
  environment: string;
  ok: boolean;
  skipped?: boolean;       // true si l'upload a été skip car CDN de cet env pas configuré (warning, pas erreur)
  targetPath: string;
  sshOutput: string;
  error: string;
}

export interface DeployResponse {
  pack: ResourcePack;
  results: DeployResultEntry[];
}

const baseUrl = (pid: string) => `/api/projects/${pid}/resource-packs`;

export const resourcePacksService = {
  list: (pid: string) => apiFetch<ResourcePack[]>(baseUrl(pid)),
  get: (pid: string, id: string) => apiFetch<ResourcePack>(`${baseUrl(pid)}/${id}`),
  create: (pid: string, input: PackCreateInput) =>
    apiFetch<ResourcePack>(baseUrl(pid), { method: 'POST', json: input }),
  update: (pid: string, id: string, input: PackUpdateInput) =>
    apiFetch<ResourcePack>(`${baseUrl(pid)}/${id}`, { method: 'PATCH', json: input }),
  remove: (pid: string, id: string) =>
    apiFetch<void>(`${baseUrl(pid)}/${id}`, { method: 'DELETE' }),
  sync: (pid: string, id: string) =>
    apiFetch<ResourcePack>(`${baseUrl(pid)}/${id}/sync`, { method: 'POST' }),
  syncAll: (pid: string) =>
    apiFetch<{ ok: number; ko: number; errors: string[] }>(`${baseUrl(pid)}/sync`, { method: 'POST' }),
  deploy: (pid: string, id: string, input: DeployPackInput) =>
    apiFetch<DeployResponse>(`${baseUrl(pid)}/${id}/deploy`, { method: 'POST', json: input }),
};
